import React, { useState } from 'react';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import { Link } from 'react-router';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import dayjs from 'dayjs';

import './style.scss';
import { getAssessmentAssignedInfo } from '../../client';
import { isEmpty } from 'lodash';

const AssessmentAssignedInfoPopover = ({
  title,
  assessmentId,
  assignmentsIds,
  subjectId,
  educationPeriod,
  isStudent,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [assessmentAssignedInfo, setAssessmentAssignedInfo] = useState([]);

  const handleClick = () => {
    if (!isStudent) {
      setIsLoading(true);
      getAssessmentAssignedInfo(assessmentId, educationPeriod).then(
        (assessmentAssignedInfoData) => {
          if (!isEmpty(assessmentAssignedInfoData)) {
            setAssessmentAssignedInfo(assessmentAssignedInfoData);
          }
        },
      );
      setIsLoading(false);
    }
  };

  const renderTrigger = () => {
    return (
      <div className="w-24" onClick={handleClick}>
        {title.replace(/"/g, '')}
      </div>
    );
  };

  const renderContentList = () => {
    return (assessmentAssignedInfo || [])
      .filter(({ assignmentId }) => assignmentsIds.includes(assignmentId))
      .map(({ assignmentId, sectionName, scoredDateMax, scoredDateMin }) => {
        return (
          <li className="grid">
            <span className="flex justify-between">
              <Link
                to={`/${subjectId}/assessments/results/${assignmentId}/resources`}
                onlyActiveOnIndex={false}
              >
                {sectionName}
              </Link>
              <span className="text-gray-900 text-base">
                {dayjs(scoredDateMin).format('MM/DD/YY')}-
                {dayjs(scoredDateMax).format('MM/DD/YY')}
              </span>
            </span>
          </li>
        );
      });
  };

  const renderContent = () => {
    return (
      <div className="assessment-assigned-info-content-wrapper">
        <h3 className="header">{title.replace('"', '').replace('"', '')}</h3>
        <section className="header-list">
          <div className="text-gray-600">ASSIGNED TO</div>
          <div className="text-gray-600">SCORED</div>
        </section>
        <ul className="main-content grid gap-4 items-list p-0 m-0">
          {isLoading && <LoadingSpinner />}
          {!isLoading && renderContentList()}
        </ul>
      </div>
    );
  };

  if (isStudent) {
    return renderTrigger();
  }

  return (
    <PopOver
      trigger={renderTrigger()}
      size="auto"
      position="end"
      isNarrow
      withPortal
      showCloseButton
    >
      {renderContent()}
    </PopOver>
  );
};

export default AssessmentAssignedInfoPopover;
